import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
// sostituito il layout a tabella con una griglia per eliminare le righe orizzontali
import { Button } from "@/components/ui/button";
import { useQuery } from "@tanstack/react-query";
import { loadAllUnits } from "@/services/shopping/units.service";
import { useThemeConfig } from "@/components/ui/theme-config-provider";

interface UnitOption {
  id: number;
  unit_name: string;
  display_order: number;
}

interface UnitPickerDialogProps {
  open: boolean;
  selectedUnit?: string;
  onSelect: (unit: string) => void;
  onOpenChange: (open: boolean) => void;
}

const UnitPickerDialog = ({ open, selectedUnit, onSelect, onOpenChange }: UnitPickerDialogProps) => {
  const { data: units = [] } = useQuery({
    queryKey: ["allUnits"],
    queryFn: loadAllUnits,
    staleTime: 30000,
  });
  const { theme } = useThemeConfig();
  const [current, setCurrent] = useState<string | undefined>(selectedUnit);

  // Mantiene sincronizzata la selezione con il valore esterno anche prima dell'apertura
  useEffect(() => {
    setCurrent(selectedUnit);
  }, [selectedUnit, open]);

  const handleSelect = () => {
    if (current) {
      onSelect(current);
    }
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-full z-[5004]"
        overlayClassName="z-[5003]"
        style={{
          backgroundColor: theme.cardBackgroundColor,
          borderRadius: theme.cardBorderRadius,
          borderColor: theme.borderColor,
          color: theme.textColor,
        }}
      >
        <DialogHeader>
          <DialogTitle>Seleziona unità di misura<br/><br/></DialogTitle>
        </DialogHeader>
        <div className="max-h-75 overflow-y-auto">
          <div className="grid grid-cols-3 gap-2">
            {units.map((unit) => (
              <button
                key={unit.id}
                type="button"
                className="w-full rounded-md px-2 py-[5px] focus:outline-none"
                style={{
                  backgroundColor:
                    current === unit.unit_name ? theme.primaryColor : theme.backgroundColor,
                  color:
                    current === unit.unit_name ? theme.textPrimaryColor : theme.primaryColor,
                  borderRadius: theme.buttonBorderRadius,
                }}
                onClick={() => setCurrent(unit.unit_name)}
              >
                {unit.unit_name}
              </button>
            ))}
          </div>
        </div>
        <DialogFooter className="mt-4 flex flex-row justify-between sm:justify-between sm:space-x-0">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            style={{
              backgroundColor: theme.backgroundColor,
              color: theme.textColor,
              borderRadius: theme.buttonBorderRadius,
              padding: theme.buttonPadding,
              fontWeight: theme.buttonFontWeight,
              transitionDuration: theme.transitionSpeed,
              borderColor: theme.borderColor,
            }}
          >
            Annulla
          </Button>
          <Button
            onClick={handleSelect}
            disabled={!current}
            className="hover:bg-[var(--btn-bg-hover)]"
            style={{
              backgroundColor: theme.primaryColor,
              color: theme.textPrimaryColor,
              borderRadius: theme.buttonBorderRadius,
              padding: theme.buttonPadding,
              fontWeight: theme.buttonFontWeight,
              transitionDuration: theme.transitionSpeed,
              // @ts-ignore custom css var
              '--btn-bg-hover': theme.primaryColor,
            }}
          >
            Seleziona
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UnitPickerDialog;
